import { useNavigate } from 'react-router-dom';
import { store } from '../../stateManagement/store';
import { getItemWebStorage, setItemWebStorage } from '../../features/webStorageSaver';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import { IndorImages, getIndorImageSrc } from '../../features';
import { highlightSearchValueInText } from '../../features/textHighlighter/textHighlighter';
import { setSelectedPath } from '../../stateManagement/reducers';
import { classNames } from 'primereact/utils';

const goToCardButtonIconSrc = getIndorImageSrc(IndorImages.MessageInfo);
const goToMapButtonIconSrc = getIndorImageSrc(IndorImages.Map);

type PathItemProps = {
    path: any,
    isInRaion: boolean,
    raionId?: string
}

// Компонент - объект с наименованием дороги и направления на странице "Выбор дорог и направлений"
export function PathItem({ path, isInRaion, raionId }: PathItemProps) {
    const navigate = useNavigate()
    const { selectedPath, idsOfPathsWithGeometry, pathsSearchValue } = useAppSelector(state => state.pathsInfo)
    const { Name: pathName, RoadName: roadName, PathID: pathId, RoadId: roadId } = path ?? {}
    const pathDescription = `${roadName} ${pathName}`
    const pathIsActive = selectedPath?.pathId === pathId
    const pathHasGeometry = idsOfPathsWithGeometry?.includes(`${pathId}`)

    function goToCard(event: any) {
        event.stopPropagation();
        navigate(`/app/road/${roadId}`)
    }

    function goToMap(event: any) {
        event.stopPropagation();
        navigate(`/app/map/path/${pathId}`)
    }

    function selectPath() {
        const newSelectedPath = { pathName, pathId, roadName, roadId, raionId }
        store.dispatch(setSelectedPath(newSelectedPath))
        const localPathsInfo = getItemWebStorage('pathsInfo')
        const newPathsInfo = { ...localPathsInfo, selectedPath: newSelectedPath }
        setItemWebStorage('pathsInfo', newPathsInfo)
    }

    const pathClassnames = classNames({
        "roads-list-path-item": true,
        "active": pathIsActive,
        "in-raion": isInRaion
    })

    return (
        <div tabIndex={pathId} className={pathClassnames} onClick={selectPath}>
            {isInRaion && <div className="in-raion-mark-div" />}
            <span className='path-description'>{highlightSearchValueInText(pathDescription, pathsSearchValue)}</span>
            <div className='navigation-buttons'>
                <img className='go-to-card-button' onClick={goToCard} src={goToCardButtonIconSrc} />
                {pathHasGeometry &&
                    <img className='go-to-map-button' onClick={goToMap} src={goToMapButtonIconSrc} />
                }
            </div>
        </div>
    )
}
